import moment from "moment";

export const translate = (label) => {
  const local = localStorage.getItem("i18nextLng");
  return local.indexOf("fr") !== -1 ? `${label}_fr` : label;
};

export const getFormattedMonth = (isoDate) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  if (isoDate) {
    const date = moment(isoDate);
    return months[date.month()].slice(0, 3);
  }
  return "";
};

export const getFormattedDay = (isoDate) => {
  if (isoDate) {
    const date = moment(isoDate);
    return date.date();
  }
  return "--/--/----";
};

export const getFormattedYear = (isoDate) => {
  if (isoDate) {
    const date = moment(isoDate);
    return date.year();
  }
  return "";
};
